import { motion } from 'framer-motion';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SecurityIcon from '@mui/icons-material/Security';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

const cards = [
  {
    icon: <RocketLaunchIcon sx={{ fontSize: 28, color: '#CB88F9' }} />,
    title: 'Implementação Rápida',
    description: 'Configure sua conta e comece a usar em menos de 24 horas.',
  },
  {
    icon: <TrendingUpIcon sx={{ fontSize: 28, color: '#CB88F9' }} />,
    title: 'Automação de Vendas',
    description: 'Acelere o ciclo de vendas com propostas automatizadas.',
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 28, color: '#CB88F9' }} />,
    title: 'Segurança Máxima',
    description: 'Criptografia de ponta e conformidade com LGPD.',
  },
  {
    icon: <HeadsetMicIcon sx={{ fontSize: 28, color: '#CB88F9' }} />,
    title: 'Suporte Dedicado',
    description: 'Equipe especializada disponível sempre que precisar.',
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } },
};

const PricingCards = () => (
  <motion.div
    className="grid grid-cols-1 sm:grid-cols-2 gap-4"
    variants={containerVariants}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    {cards.map((card) => (
      <motion.div
        key={card.title}
        variants={cardVariants}
        className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 p-6"
      >
        <div className="w-12 h-12 bg-[#f3e8ff] rounded-xl flex items-center justify-center mb-4">
          {card.icon}
        </div>
        <h3 className="text-[--primary-color] font-bold text-base mb-2">{card.title}</h3>
        <p className="text-gray-500 text-sm font-light leading-relaxed">{card.description}</p>
      </motion.div>
    ))}
  </motion.div>
);

export default PricingCards;